module.exports = __webpack_public_path__ + "img/img6.908b4bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/img6.png
// module id = 377
// module chunks = 0